import shippingStatuses from '@/data/shipping-statuses-map'

export default {
  methods: {
    getShippingStatus (status) {
      return shippingStatuses[status] || shippingStatuses.OPEN
    }
  }
}
